export const PAYMENT_TYPES_STAFF = [
  {
    id: 'CHECK',
    name: 'Check',
  },
  {
    id: 'EFT',
    name: 'EFT',
  },
  {
    id: 'STRIPE',
    name: 'Stripe',
  },
  {
    id: 'LEGACY_CARD',
    name: 'Authorize.net / Paypal (legacy)',
  },
  {
    id: 'CREDIT',
    name: 'Job/Internship/Fair Credit',
  },
  {
    id: 'PROMO_CREDIT',
    name: 'Promo Credit',
  },
  {
    id: 'VOID',
    name: 'Void',
  },
  {
    id: 'LEGACY_BUG',
    name: 'Unknown',
  },
] as const satisfies { id: string; name: string }[];
